import { useSelector } from '@topwrite/common';

export default function useFile() {
    const { file } = useSelector('page');

    return file;
}
